// Static mock data for the demo portal template.
// All content mirrors the problem statement exactly, with extra detail for a realistic demo.

export const overviewStats = [
  {
    key: "clients",
    label: "Active Clients",
    value: 12,
    change: "+2 this week",
    trend: "up",
    icon: "users",
  },
  {
    key: "tasks",
    label: "Pending Tasks",
    value: 7,
    change: "3 due today",
    trend: "flat",
    icon: "list-checks",
  },
  {
    key: "orders",
    label: "Open Orders",
    value: 3,
    change: "1 awaiting payment",
    trend: "flat",
    icon: "receipt",
  },
  {
    key: "workflow",
    label: "Workflow Status",
    value: "In Progress",
    change: "4 stages active",
    trend: "up",
    icon: "git-branch",
  },
];

export const quickActions = [
  { key: "add-client", label: "Add New Client", icon: "user-plus" },
  { key: "create-task", label: "Create Task", icon: "plus" },
  { key: "update-order", label: "Update Order", icon: "refresh-cw" },
  { key: "view-workflow", label: "View Workflow", icon: "git-branch" },
];

export const snapshotSeries = [
  { month: "Jan", clients: 4, orders: 2 },
  { month: "Feb", clients: 6, orders: 3 },
  { month: "Mar", clients: 5, orders: 4 },
  { month: "Apr", clients: 8, orders: 5 },
  { month: "May", clients: 9, orders: 4 },
  { month: "Jun", clients: 10, orders: 6 },
  { month: "Jul", clients: 12, orders: 7 },
];

export const clients = [
  {
    id: "c1",
    name: "John Doe",
    company: "Doe & Co.",
    email: "john.doe@example.com",
    phone: "(555) 012-3456",
    status: "Active",
    added: "2025-11-02",
    notes: "Prefers email contact. Interested in extended service plan.",
    tasks: ["Send invoice", "Schedule review call"],
    orders: ["Order #101"],
    documents: ["Agreement.pdf"],
  },
  {
    id: "c2",
    name: "Maria Lopez",
    company: "Lopez Studios",
    email: "maria.lopez@example.com",
    phone: "(555) 234-8891",
    status: "Pending",
    added: "2026-01-12",
    notes: "Awaiting signed proposal. Follow up Tuesday.",
    tasks: ["Follow up"],
    orders: [],
    documents: ["Proposal.docx"],
  },
  {
    id: "c3",
    name: "Kevin Smith",
    company: "Smith Logistics",
    email: "kevin.smith@example.com",
    phone: "(555) 908-1023",
    status: "Completed",
    added: "2025-09-20",
    notes: "Project closed. Happy client — request testimonial.",
    tasks: [],
    orders: ["Order #088", "Order #092"],
    documents: ["Receipt.pdf", "Final report.pdf"],
  },
  {
    id: "c4",
    name: "Angela Brown",
    company: "Brown Wellness",
    email: "angela.brown@example.com",
    phone: "(555) 445-1277",
    status: "Active",
    added: "2025-12-04",
    notes: "Requires monthly reporting. High priority.",
    tasks: ["Upload documents", "Monthly report"],
    orders: ["Order #103"],
    documents: ["Intake form.pdf"],
  },
];

export const tasks = [
  {
    id: "t1",
    title: "Send invoice to John Doe",
    due: "Due Today",
    status: "Pending",
    priority: "High",
    client: "John Doe",
  },
  {
    id: "t2",
    title: "Follow up with Maria Lopez",
    due: "Due Tomorrow",
    status: "Pending",
    priority: "Medium",
    client: "Maria Lopez",
  },
  {
    id: "t3",
    title: "Update order status for Kevin Smith",
    due: "This Week",
    status: "In Progress",
    priority: "Medium",
    client: "Kevin Smith",
  },
  {
    id: "t4",
    title: "Upload documents for Angela Brown",
    due: "No due date",
    status: "Pending",
    priority: "Low",
    client: "Angela Brown",
  },
];

export const workflowStages = [
  {
    id: "w1",
    number: 1,
    title: "Client Intake",
    description: "Collect client details and confirm service needs.",
    status: "Completed",
    items: ["New client form", "Intake call booked"],
  },
  {
    id: "w2",
    number: 2,
    title: "Service Delivery",
    description: "Perform the service or complete the task.",
    status: "In Progress",
    items: ["Active projects: 3", "On-site visits scheduled"],
  },
  {
    id: "w3",
    number: 3,
    title: "Review & Follow-Up",
    description: "Confirm satisfaction and gather feedback.",
    status: "Upcoming",
    items: ["Feedback forms ready"],
  },
  {
    id: "w4",
    number: 4,
    title: "Completion",
    description: "Close out the project and archive documents.",
    status: "Upcoming",
    items: ["Archive folder ready"],
  },
];

export const orders = [
  {
    id: "o1",
    number: "#101",
    client: "John Doe",
    amount: "$1,240.00",
    date: "2026-02-01",
    status: "In Progress",
  },
  {
    id: "o2",
    number: "#102",
    client: "Kevin Smith",
    amount: "$860.00",
    date: "2026-01-18",
    status: "Completed",
  },
  {
    id: "o3",
    number: "#103",
    client: "Angela Brown",
    amount: "$2,300.00",
    date: "2026-02-05",
    status: "Pending Payment",
  },
];

export const documents = [
  {
    id: "d1",
    name: "Placeholder Document.pdf",
    size: "284 KB",
    type: "PDF",
    uploaded: "2026-02-03",
  },
  {
    id: "d2",
    name: "Placeholder Contract.docx",
    size: "56 KB",
    type: "DOCX",
    uploaded: "2026-01-28",
  },
];

export const messages = [
  {
    id: "m1",
    from: "System",
    role: "system",
    text: "Welcome to your portal! Let us know if you need help.",
    time: "09:12",
  },
  {
    id: "m2",
    from: "Client",
    role: "client",
    text: "Thanks! I'm reviewing my tasks now.",
    time: "09:14",
  },
];

export const conversations = [
  {
    id: "conv1",
    name: "John Doe",
    preview: "Thanks for the invoice — will pay today.",
    time: "09:40",
    unread: 0,
  },
  {
    id: "conv2",
    name: "Maria Lopez",
    preview: "Could we reschedule to Thursday?",
    time: "08:55",
    unread: 2,
  },
  {
    id: "conv3",
    name: "Angela Brown",
    preview: "Uploaded the intake form.",
    time: "Yesterday",
    unread: 0,
  },
];

export const businessInfo = {
  name: "Your Business Portal",
  logo: "",
  phone: "(555) 000-1234",
  email: "hello@yourbusiness.com",
  hours: "Mon–Fri, 9:00 AM – 6:00 PM",
  serviceArea: "United States",
  about:
    "A premium template portal designed for modern small businesses. Organize clients, tasks, orders, and workflow in one clean workspace.",
};

export const demoUser = {
  name: "Demo User",
  email: "demo@demo.com",
  role: "Owner",
  avatar: "",
};
